__turbopack_context__.v({
  "chapter-meta": "styles-module__kNdyia__chapter-meta",
  "comment": "styles-module__kNdyia__comment",
  "default": "styles-module__kNdyia__default",
  "editable": "styles-module__kNdyia__editable",
  "editor": "styles-module__kNdyia__editor",
  "header": "styles-module__kNdyia__header",
  "journal": "styles-module__kNdyia__journal",
  "mini": "styles-module__kNdyia__mini",
  "placeholder": "styles-module__kNdyia__placeholder",
  "post": "styles-module__kNdyia__post",
  "prose": "styles-module__kNdyia__prose",
});
